import React, { useState } from "react";
import ModalCard from "../../../components/ModalCard";
import {
  blackColor,
  blackShade159,
  whiteColor,
} from "../../../configs/styles/muiThemes";
import PickAddress from "../../BusinessOnBoard/Forms/PickAddress";
import { Box, Typography } from "@mui/material";
import AddressInfoForm from "../../BusinessOnBoard/Forms/AddressInfoForm";

const AddressPicker = ({
  open,
  handleClose,
  addressDetails,
  handlePickLocationConfirm,
  onValueChange
}) => {
  const [currentPage, setCurrentPage] = useState("address-info");

  return (
    <ModalCard
      open={open}
      handleClose={handleClose}
      width="36%"
      modalType="auth"
      hideClose
    >
      <Box overflow="hidden">
        <Box sx={styles.content}>
          <Box>
            <Typography sx={styles.titleText}>Add Business Address</Typography>
          </Box>
          <Box>
            {currentPage === "pick-address" && (
              <PickAddress
                onConfirm={(data) => {
                  handlePickLocationConfirm(data);
                  setCurrentPage("address-info");
                }}
                userLat={addressDetails?.lat || ""}
                userLong={addressDetails?.lng || ""}
                onBackClick={() => {}}
                hideBackBtn
              />
            )}

            {currentPage == "address-info" && (
              <AddressInfoForm
                handleNext={handleClose}
                handleBack={()=>{setCurrentPage('pick-address')}}
                addressDetails={addressDetails}
                onValueChange={onValueChange}
                setCurrentPage={setCurrentPage}
              />
            )}
          </Box>
        </Box>
      </Box>
    </ModalCard>
  );
};

export default AddressPicker;

const styles = {
  content: {
    maxHeight: "95vh",
    backgroundColor: whiteColor,
    borderRadius: "10px",
    // padding: { xs: "20px", md: "25px" },

    overflowY: "auto",

    "&::-webkit-scrollbar": {
      width: "4px",
      // height: "1px",
    },
    "&::-webkit-scrollbar-thumb": {
      background: blackShade159,
      borderRadius: "50px !important",
    },
    "&::-webkit-scrollbar-track": {
      background: "#f1f1f1",
      borderRadius: "50px !important",
    },
  },

  titleText: {
    fontSize: 14,
    fontWeight: 600,
    color: blackColor,
    mb: 1,
    letterSpacing: "-0.3px",
    lineHeight: "14px",
    p: {xs:'15px 10px 5px 10px', md:"15px 15px 10px 20px"},
  },
};
